import {HttpContextToken} from '@angular/common/http';

export const AUTH_TOKEN_HTTP_CONTEXT = new HttpContextToken<string>(() => '');
